var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"950px","persistent":"","scrollable":"","retain-focus":false,"basicstyles":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.permissionCan('create'))?_c('v-btn',_vm._g(_vm._b({staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.$emit('new')}}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.$t("MENU.NEW"))+" "+_vm._s(_vm.$t("MENU.INSTITUTE"))+" ")]):_vm._e()]}}]),model:{value:(_vm.modalData.dialog),callback:function ($$v) {_vm.$set(_vm.modalData, "dialog", $$v)},expression:"modalData.dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle)+" ")]),_c('v-btn',{staticClass:"close-button",attrs:{"icon":""},on:{"click":_vm.handleCloseModalForm}},[_c('v-icon',[_vm._v(" mdi-close")])],1)],1)],1)],1),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"12","sm":"2","md":"2"}},[_c('v-select',{attrs:{"items":_vm.languages,"disabled":_vm.languages.length == 1},scopedSlots:_vm._u([{key:"selection",fn:function(slotProps){return [_c('span',{staticClass:"symbol symbol-20 mr-3"},[_c('img',{attrs:{"src":_vm.selectedLocale.flag,"alt":""}})]),_vm._v(" "+_vm._s(slotProps.item.name)+" ")]}},{key:"item",fn:function(slotProps){return [_c('span',{staticClass:"symbol symbol-20 mr-3"},[_c('img',{attrs:{"src":slotProps.item.flag,"alt":""}})]),_c('span',{staticClass:"navi-text"},[_vm._v(_vm._s(slotProps.item.name))])]}}]),model:{value:(_vm.selectedLocale),callback:function ($$v) {_vm.selectedLocale=$$v},expression:"selectedLocale"}})],1),_c('v-col',{attrs:{"cols":"12","sm":"2","md":"2"}},[(_vm.statuses.institutes)?_c('v-select',{attrs:{"items":_vm.statuses.institutes.institute,"label":_vm.$t('FORMS.status'),"item-text":"value","item-value":"key"},scopedSlots:_vm._u([{key:"selection",fn:function(slotProps){return [_vm._v(" "+_vm._s(_vm.$t("STATUSES." + slotProps.item.value))+" ")]}},{key:"item",fn:function(slotProps){return [_c('span',{staticClass:"navi-text"},[_vm._v(_vm._s(_vm.$t("STATUSES." + slotProps.item.value)))])]}}],null,false,380766273),model:{value:(_vm.formModel.status),callback:function ($$v) {_vm.$set(_vm.formModel, "status", $$v)},expression:"formModel.status"}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"8"}},[(_vm.formModel.translations[_vm.selectedLocale.lang])?_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":_vm.$t('FORMS.name'),"id":_vm.dynamicID,"error-messages":_vm.messages['translations.' + _vm.selectedLocale.lang + '.name']},on:{"keyup":function($event){_vm.messages['translations.' + _vm.selectedLocale.lang + '.name'] = ''}},model:{value:(_vm.formModel.translations[_vm.selectedLocale.lang].name),callback:function ($$v) {_vm.$set(_vm.formModel.translations[_vm.selectedLocale.lang], "name", $$v)},expression:"formModel.translations[selectedLocale.lang].name"}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"4"}},[(
                _vm.formModel.id && _vm.formModel.translations[_vm.selectedLocale.lang]
              )?_c('v-text-field',{attrs:{"label":_vm.$t('FORMS.slug'),"id":_vm.dynamicID,"error-messages":_vm.messages['translations.' + _vm.selectedLocale.lang + '.slug']},on:{"keyup":function($event){_vm.messages['translations.' + _vm.selectedLocale.lang + '.slug'] = ''}},model:{value:(_vm.formModel.translations[_vm.selectedLocale.lang].slug),callback:function ($$v) {_vm.$set(_vm.formModel.translations[_vm.selectedLocale.lang], "slug", $$v)},expression:"formModel.translations[selectedLocale.lang].slug"}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"featured_image","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .featured_image || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'title',
                    label: 'FORM_INPUT_NAMES.title',
                    type: 'text',
                  } ],
                selectButtonText: 'FORM_INPUT_NAMES.featured_image',
                resolution: '1128x677',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-divider'),_c('h6',[_vm._v("Regional stakeholder partners")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk1_logo1","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk1_logo1 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk1_logo2","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk1_logo2 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-divider'),_c('h6',[_vm._v("Higher education institutional partners")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk2_logo1","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk2_logo1 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk2_logo2","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk2_logo2 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-divider'),_c('h6',[_vm._v("Scientific / research partner institutions")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk3_logo1","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk3_logo1 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"blokk3_logo2","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .blokk3_logo2 || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"institute_logo","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .institute_logo || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'Intézmény logó',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"6","xs":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"last_image","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .last_image || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                inputFields: [
                  {
                    name: 'alt_text',
                    label: 'FORM_INPUT_NAMES.alt_text',
                    type: 'text',
                  },
                  {
                    name: 'url',
                    label: 'FORM_INPUT_NAMES.url',
                    type: 'text',
                  } ],
                selectButtonText: 'FORM_INPUT_NAMES.select_image',
                resolution: '1275x850',
                initialColumnClass:
                  'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"config":{
                type: 'text',
                label: 'FORMS.seo_title',
                charLimit: 60,
              },"customFieldName":"seoTitle","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .seoTitle},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"config":{
                type: 'textarea',
                label: 'FORMS.seo_description',
                charLimit: 160,
              },"customFieldName":"seoDescription","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .seoDescription},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"8"}},[_c('v-row',[_c('v-col',{staticClass:"mt-2",attrs:{"cols":"12","sm":"6","md":"6"}},[(
                    _vm.formModel.translations[_vm.selectedLocale.lang] &&
                    _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  )?_c('CustomFieldComponent',{attrs:{"config":{
                    type: 'text',
                    label: 'FORM_INPUT_NAMES.og_title',
                  },"customFieldName":"og_title","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                      .og_title || ''},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"6"}},[(_vm.formModel && _vm.formModel.custom_fields)?_c('CustomFieldComponent',{attrs:{"config":{
                    type: 'multi_select',
                    multiple: false,
                    label: _vm.$t('FORM_INPUT_NAMES.og_type'),

                    items: _vm.og_types,
                  },"customFieldName":"og_type","value":_vm.formModel.custom_fields.og_type || 'website'},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(
                    _vm.formModel.translations[_vm.selectedLocale.lang] &&
                    _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  )?_c('CustomFieldComponent',{attrs:{"config":{
                    type: 'textarea',
                    label: 'FORM_INPUT_NAMES.og_description',
                  },"customFieldName":"og_description","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                      .og_description || ''},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1)],1),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"4"}},[(
                _vm.formModel.translations[_vm.selectedLocale.lang] &&
                _vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
              )?_c('CustomFieldComponent',{attrs:{"customFieldName":"og_image","value":_vm.formModel.translations[_vm.selectedLocale.lang].custom_fields
                  .og_image || '',"config":{
                type: 'media_selector',
                maxFiles: 1,
                selectButtonText: 'FORM_INPUT_NAMES.og_image',
                initialColumnClass:
                  'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12',
              }},on:{"handleChangeCustomFieldValue":_vm.handleChangeCustomFieldValue}}):_vm._e()],1)],1)],1)],1),_c('v-card-actions',{staticClass:"mb-2"},[_c('v-spacer'),(
          (_vm.permissionCan('create') && !_vm.formModel.id) ||
          _vm.permissionCan('update')
        )?_c('v-btn',{attrs:{"color":"primary","elevation":"2"},on:{"click":_vm.handleSaveModalForm}},[_vm._v(" "+_vm._s(_vm.$t("FORMS.save"))+" ")]):_vm._e()],1),_c('SnackBarInfoComponent',{attrs:{"snackbarInfo":_vm.snackbarInfo}})],1),_c('v-overlay',{attrs:{"value":_vm.loader}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }